import { useMutation } from 'react-query'

import AIGenerationService from 'src/services/ai-generation.service'

import { AIGenerateContentPrompt } from 'src/types'
import { QUERY_KEYS } from 'src/constants'

const useGeneratedDescription = (type: AIGenerateContentPrompt, locale?: string) => {
  return useMutation(QUERY_KEYS.GENERATE_DESCRIPTION, (text: string) =>
    AIGenerationService.getGeneratedDescription({
      promptTag: type,
      text,
      prompt: null,
      locale: locale ? locale : 'en',
    }),
  )
}

export { useGeneratedDescription }
